import React, { useState } from 'react';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

function OneTapButton(props) {
    const [isHovered, setIsHovered] = useState(false);

    const baseButtonStyle = {
        flexGrow: 0,
        flexBasis: 'calc(33.333% - 16px)',
        maxWidth: 'calc(33.333% - 16px)',
        margin: '8px',
        background: 'linear-gradient(to right bottom, #ffffff, #f0f7ff)',
        border: '2px solid rgb(173, 209, 212)',
        borderRadius: '8px',
        padding: '10px 20px',
        fontSize: '17px',
        cursor: 'pointer',
        transition: 'background-color 0.3s',
        textAlign: 'left',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center'
    };

    const baseTextStyle = {
        margin: 1,
        padding: 0,
    };

    const firstLineStyle = {
        ...baseTextStyle,
        fontWeight: 'bold',
    };

    const secondLineStyle = {
        ...baseTextStyle,
        fontWeight: 'normal',
        fontSize: '14px',
    };

    const hoverStyle = {
        ...baseButtonStyle,
        background: '#E0E0E0'
    };

    return (
        <button
            style={isHovered ? hoverStyle : baseButtonStyle}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={props.onClick}
        >
            <span style={firstLineStyle}>
                {props.title}
            </span>
            <span style={secondLineStyle}>{props.subtitle}</span>
        </button>
    );
}

export default OneTapButton;
